import React from 'react'
// libs
import styled from 'styled-components'
// components
import { Button, BUTTON_LAYOUTS, CREATE_BUTTON_STYLE } from 'components/UI'

const ButtonWrapper = styled.div`
  padding: 2rem;
  display: flex;
  justify-content: center;
  min-height: 48px;
`

interface Props {
  loading: boolean
  hasMore: boolean
  loadMore: () => Promise<void>
}

const Footer: React.FC<Props> = ({ loadMore, hasMore, loading }) => {
  return (
    <ButtonWrapper>
      {hasMore && (
        <Button
          disabled={loading}
          onClick={loadMore}
          isLoading={loading}
          style={CREATE_BUTTON_STYLE}
          layout={BUTTON_LAYOUTS.PURPLE}>
          Press to load more
        </Button>
      )}
    </ButtonWrapper>
  )
}

export default Footer
